<div class="buffer">
    <form *ngIf="!buffering">
        <div *ngIf="warningMsg" class="field-container">
            <p class="alert alert-red is-active">
                <strong>Warning:&nbsp;</strong>{{ warningMsg }}
            </p>
        </div>
        <div class="field-container" *ngIf="showSettings.type">
            <span>Buffer Type:</span>
            <span>
                <input type="radio" name="group" id="singleBufferRadio" class="k-radio" [(ngModel)]="multiBuffer" value="false" (change)="checkFilteredLayerWarning()" checked />
                <span for="singleBufferRadio">Single</span>
            </span>
            <span>
                <input type="radio" name="group" id="multiBufferRadio" [(ngModel)]="multiBuffer" value="true" class="k-radio" />
                <span for="multiBufferRadio" class="buffer-radio-multi">Multiple</span>
            </span>
        </div>
        <div class="field-container" *ngIf="(multiBuffer !== 'true') && showSettings.distance">
            <label for="distance">Buffer Distance:</label>
            <input id="distance" name="distance" class="k-textbox" type="number" placeholder="Choose distance" [(ngModel)]="bufferDistance" />
        </div>
        <div class="field-container" *ngIf="(multiBuffer === 'true') && showSettings.distance">
            <label for="distance">Buffer Distance:</label>
            <input id="distance" name="distance" class="k-textbox" type="text" placeholder="Choose distance" [(ngModel)]="bufferDistance" (change)="checkFilteredLayerWarning()" />
        </div>
        <div class="field-container" *ngIf="(multiBuffer === 'true') && showSettings.distance">
            <div>Enter comma separated numbers for multiple buffers.</div>
        </div>
        <div class="field-container" *ngIf="showSettings.distanceUnit">
            <label for="distanceUnits">Buffer Distance Units:</label>
            <select id="distanceUnits" name="distanceUnits" [(ngModel)]="bufferOptions.distanceUnit">
                <option *ngFor="let option of distanceUnits" [value]="option.value">{{ option.name }}</option>
            </select>
        </div>
        <div class="field-container" *ngIf="showSettings.areaUnit">
            <label for="areaUnit">Buffer Area Unit:</label>
            <select id="areaUnits" name="areaUnits" [(ngModel)]="bufferOptions.areaUnit">
                <option *ngFor="let option of areaUnits" [value]="option.value">{{ option.name }}</option>
            </select>
        </div>
        <div class="field-container" *ngIf="showSettings.fillType">
            <label for="fillType">Fill Type:</label>
            <select id="fillType" name="fillType" [(ngModel)]="bufferOptions.fillType">
                <option *ngFor="let option of fillTypes" [value]="option.value">{{ option.name }}</option>
            </select>
        </div>
        <div class="field-container" *ngIf="showSettings.fillColor">
            <span>Fill Color:</span>
            <mc-color-picker-ng #fillColorPicker [(color)]="bufferOptions.fillColor" [siblingColorPickers]="[outlineColorPicker]"></mc-color-picker-ng>
        </div>
        <div class="field-container" *ngIf="showSettings.outlineType">
            <label for="outlineType">Outline Type:</label>
            <select id="outlineType" name="outlineType" [(ngModel)]="bufferOptions.outlineType">
                <option *ngFor="let option of outlineTypes" [value]="option.value">{{ option.name }}</option>
            </select>
        </div>
        <div class="field-container" *ngIf="showSettings.outlineColor">
            <span>Outline Color:</span>
            <mc-color-picker-ng #outlineColorPicker [(color)]="bufferOptions.outlineColor" [siblingColorPickers]="[fillColorPicker]"></mc-color-picker-ng>
        </div>
        <div *ngIf="bufferableLayers && bufferableLayers.length>0" class="field-container">
            <label for="test">Layers:</label>
            <mc-select-ng controlLabel="Bufferable layers"
                          [data]="bufferableLayers"
                          isMultiSelect="true"
                          isSearchable="true"
                          label="customLabel"
                          [(model)]="selectedLayers"
                          (modelChange)="checkFilteredLayerWarning()"
                          placeholderText="Optional layers to apply buffer"
                          value="id">
            </mc-select-ng>
        </div>
        <div *ngIf="warningMsg" class="field-container">
            <p class="alert alert-red is-active">
                <strong>Warning:&nbsp;</strong>{{ warningMsg }}
            </p>
        </div>
        <button class="btn btn-small" *ngIf="!(options && (options.showContinueButton === false || options.showContinueButton === 'false'))" (click)="buffer()">Continue</button>
    </form>

    <div *ngIf="buffering">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">Loading...</div>
        </div>
    </div>
</div>
